import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenmilo: "",
    adminmilo: []
  },
  mutations: {
    login(state, data) {
      state.adminmilo = data.user;
      state.tokenmilo = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminmilo = [];
      state.tokenmilo = "";
    },
    adminmilo(state, data) {
      state.adminmilo = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminmilo", data);
    }
  }
});
